import QuoteFormWrapper from "../../../../shared/components/quoteFormWrapper";
import PortalBackButton from "../PortalBackButton";
import QuoteStepHeading from "../../../../shared/components/QuoteStepHeading";
import PageContentStack from "../../../../shared/components/PageContentStack";

const ReportClaimFormIframe = () => {
  return (
    <PageContentStack>
      <QuoteFormWrapper>
        <QuoteStepHeading
          title="Report a Claim"
          description="Please fill out the form below to report your claim."
          className="tw-mb-6"
        />
        <iframe
          title="Report a claim form"
          width="640px"
          height="560px"
          src="https://forms.office.com/e/tMsG18UXam?embed=true"
          frameBorder="0"
          marginWidth="0"
          marginHeight="0"
          className="tw-w-full tw-border-0"
          style={{ maxWidth: "100%", maxHeight: "100vh" }}
          allowFullScreen
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          msallowfullscreen="true"
        />
      </QuoteFormWrapper>
      <PortalBackButton />
    </PageContentStack>
  );
};

export default ReportClaimFormIframe;
